<!--
  Author: Gary Hammock
  Version: 0.1.0
  Description: A navigation bar that persists across pages.
-->

<template>
  <b-navbar
    id="gh-navbar"
    toggleable="sm"
    type="dark"
    aria-label="navigation with external links"
  >
    <b-navbar-brand to="/">
      <b-img
        v-bind="iconProps"
        src="/assets/img/logo.svg"
      />
      Gary Hammock
    </b-navbar-brand>
    <b-navbar-toggle target="nav-collapse" />
    <b-collapse
      id="nav-collapse"
      is-nav
    >
      <b-navbar-nav class="ml-auto">
        <b-nav-item
          v-for="(linkObj, index) in navLinks"
          :key="index"
          :href="linkObj.href"
          rel="noopener"
          target="_blank"
        >
          <font-awesome-icon
            :icon="['fab', linkObj.faIcon]"
            class="fa-fw"
          />
          {{ linkObj.text }}
        </b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
export default {
  name: 'Navbar',

  data () {
    return {
      iconProps: {
        width: 32,
        height: 32,
        rounded: true,
        class: 'd-inline-block align-top',
        alt: 'logo in navbar'
      },
      navLinks: [{
        text: 'LinkedIn',
        faIcon: 'linkedin',
        href: 'https://www.linkedin.com/in/garyhammock/'
      }, {
        text: 'GitHub',
        faIcon: 'github',
        href: 'https://github.com/ghammock'
      }, {
        text: 'Twitter',
        faIcon: 'twitter',
        href: 'https://twitter.com/gamergare'
      }, {
        text: 'ResearchGate',
        faIcon: 'researchgate',
        href: 'https://www.researchgate.net/profile/Gary_Hammock'
      }]
    }
  }
}
</script>

<style scoped>
#gh-navbar {
  position: sticky;
  background-color: rgba(24, 14, 52, 0.85)
}

#gh-navbar a {
  color: rgba(216, 232, 255, 0.9);
}

#gh-navbar a:hover {
  color: white;
}
</style>
